import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserInformation } from '../models/user-information';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
@Component({
  selector: 'admin-panel',
  templateUrl: '../views/admin-panel.html'
})
export class AdminPanelComponent
{
  public title: string;
  public levelAccess: number;

  public constructor(
                      private _route: ActivatedRoute,
                      public sharedVariables: VariableService
                    ) {
    this.title = "Modulo de Administración";
  }

  ngOnInit()
  {
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
                      if(this.sharedVariables.login){

                      }
                      else
                        this.title = "Error, Sesión no iniciada";
                    },this.sharedVariables.sessionTime);
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/admin-panel.component.ts